module.exports = __webpack_public_path__ + "img/carpet_four.aab1bbf4.png";